import { NgModule } from '@angular/core';
import { RoleService } from './role.service';
import { RoleBackend } from './role.backend';

@NgModule({
  providers: [RoleService, RoleBackend],
})
export class RoleModule {}
